import { Link } from "wouter";
import { ChevronRight } from "lucide-react";

interface BreadcrumbItem { name: string; href?: string }
interface BreadcrumbsProps { items: BreadcrumbItem[]; className?: string }

export default function Breadcrumbs({ items, className = "" }: BreadcrumbsProps) {
  return <nav aria-label="Breadcrumb" className={`flex items-center gap-1.5 text-xs ${className}`}>
    {items.map((item, index) => <span key={index} className="flex items-center gap-1.5">
      {index > 0 && <ChevronRight size={12} className="text-white/30" aria-hidden="true" />}
      {item.href && index < items.length - 1
        ? <Link href={item.href} className="text-white/50 hover:text-white/80 transition-colors">{item.name}</Link>
        : <span className="text-white/70" aria-current="page">{item.name}</span>}
    </span>)}
  </nav>;
}
